
  // Globaler Event Listener für alle TikTok Player Messages
  window.addEventListener('message', (event) => {
    // Prüfe, ob es eine TikTok Player Message ist
    if (event.data && event.data['x-tiktok-player']) {
      const { type, value } = event.data;
      
      // Wenn ein Video zu spielen beginnt (onStateChange: 1 = playing)
      if (type === 'onStateChange' && value === 1) {
        pauseAllOtherTikTokPlayers(event.source);
      }
    }

  });

  function pauseAllOtherTikTokPlayers(currentPlayer) {
    // Finde alle TikTok iframes
    const allTikTokIframes = document.querySelectorAll('.tiktok-player');
    
    allTikTokIframes.forEach(iframe => {
      // Pausiere alle anderen Player (nicht den aktuellen)
      if (iframe.contentWindow !== currentPlayer) {
        iframe.contentWindow.postMessage({
          type: "pause",
          value: null,
          "x-tiktok-player": true
        }, '*');
      }
    });
  }

    
  function pauseAllOtherTikTokEmbeds(currentPlayer) {
    // Finde alle TikTok iframes
    const allTikTokIframes = document.querySelectorAll('.tiktok-embed iframe');
    
    allTikTokIframes.forEach(iframe => {
      // Pausiere alle anderen Player (nicht den aktuellen)
      if (iframe.contentWindow !== currentPlayer) {
        iframe.contentWindow.postMessage({
          type: "pause",
          value: null,
          "x-tiktok-player": true
        }, '*');
      }
    });
  }